export const DEFAULT_LANGUAGE_CODE = 'en'
